import { useOverviewReleasedByProductCategory } from "api/wms/hooks";
import { useOverviewReleasedByProductCategoryListColumns } from "../utils/useOverviewReleasedByProductCategoryListColumns";
import { Table } from "components/miloDesignSystem/molecules/table";
import { Typography } from "components/miloDesignSystem/atoms/typography";
import styles from "../Overview.module.css";
import { GenericTable } from "components/common/genericTable/GenericTable";
import { useGenericTableFilters } from "components/common/genericTable/useGenericTableFilters";
import { queryString } from "utilities";
import { detailsListUiSchema } from "components/miloDesignSystem/molecules/table/uiSchemas";
import { parseTableRowData } from "components/common/genericTable/utils";

export const OverviewReleasedByProductCategory = () => {
  const { setDateFrom, setRowBy, filters } = useGenericTableFilters();
  const search = queryString.stringify(filters);
  const {
    data: itemsReleased,
    error,
    isLoading,
    isFetching,
  } = useOverviewReleasedByProductCategory(search, { keepPreviousData: true });
  const columns = useOverviewReleasedByProductCategoryListColumns(itemsReleased, filters);
  const normalizedRows = parseTableRowData(itemsReleased);

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <Typography fontSize="16" fontWeight="600">
          Wydania - Kategorie mebli
        </Typography>
        <GenericTable.RowBySelect rowBy={filters.rowBy} setRowBy={setRowBy} />
      </div>

      <div className={styles.tableWrapper}>
        <Table
          rows={normalizedRows}
          // @ts-ignore
          columns={columns}
          error={error}
          isLoading={isLoading || isFetching}
          uiSchema={detailsListUiSchema}
        />
      </div>

      <GenericTable.Footer rowBy={filters.rowBy} setDateFrom={setDateFrom} />
    </div>
  );
};
